import { createClient } from '@supabase/supabase-js'

const supabaseUrl = 'https://wgtokgqhaefbheenaubv.supabase.co'
const supabaseKey = 'sb_publishable_DCZ07CesxZiAvQY_5LMKDQ_qVenCZM8'
'eyJ0eXAiOiJKV1QiLCJhbGciOiJIUzI1NiJ9.eyJyb2xlIjoiYW5vbiIsInJlZiI6InNwYi1icDExODllM2NkZXdmdGU3IiwiaXNzIjoic3VwYWJhc2UiLCJpYXQiOjE3NzUwMzE2OTQsImV4cCI6MjA5MDYwNzY5NH0.Witdeq_-Fafmst8EG251pMdnKYdGDizXhvWthyt0xyk'

export const supabase = createClient(supabaseUrl, supabaseKey)

// Auth bootstrap helper
let authReadyPromise: Promise<void> | null = null

export function waitForSupabaseAuthReady() {
  if (!authReadyPromise) {
    authReadyPromise = (async () => {
      const { data } = await supabase.auth.getSession()
      if (data.session) return

      await new Promise<void>((resolve) => {
        const timeout = window.setTimeout(resolve, 1500)
        const {
          data: { subscription },
        } = supabase.auth.onAuthStateChange((_event, session) => {
          if (session) {
            window.clearTimeout(timeout)
            subscription.unsubscribe()
            resolve()
          }
        })
      })
    })()
  }

  return authReadyPromise
}

;(window as any).supabase = supabase
